import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class Communities {
  private _communities = new Subject<any>();
  public communities = this._communities.asObservable();
  public lang = 'fr';
  public currentCommunity = null;
  communities_list: any = [];
  
  public setCommunities (response: any) {
    this.communities_list = response;
    this.getCommunities()
  }

  public getCommunities () {
    this._communities.next(this.communities_list);
  }

  public getCurrentCommunity(community_id) {
    return this.communities_list.find((el) => el.id == parseInt(community_id));
  }
  public getLanguage(community_id) {
    if (!community_id && this.currentCommunity) {
      this.lang = this.currentCommunity.lang;
      return this.currentCommunity.lang
    }
    
    const community = this.getCurrentCommunity(community_id);
    if (community) {
      this.currentCommunity = community;
      this.lang = community.lang || 'fr';
      return community.lang
    }

    this.lang = 'fr';
    return "fr"
  }
}


// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/services/communities.service.ts